import React from 'react'
import ProjectStep from "../components/ProjectStep";
import Project from "../../../models/Project";
import {generatePath} from "react-router-dom";
import ProjectPosition from "../../../models/ProjectPosition";
import ReactDOM from "react-dom";
import {PositionWizardLayout} from "../../project-position/PositionWizard";

export default class PositionStep extends ProjectStep
{
    static TranslationKey = 'positions_step';

    static path = '/role/:roleId';
    static slug = 'role/:roleId';

    static HandleUnauthorized = false;
    static InlineFormActions = false;

    static Optional = false;

    static ValidationMethodName = 'validatePosition';

    static FormClass = "wizard-position-step";

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return false
    }

    constructor(props) {
        super(props);

        this.positionFormRef = React.createRef();

        this.state = {
            ...this.state,
            editingPositionInfo: props.location?.state?.fromReview || props.match?.params?.fromReview
        }
    }

    componentDidMount() {
        super.componentDidMount();

        // this.props.toggleDisabled(this.currentPosition().needsSetup())
    }

    isNew() {
        return this.props.roleId === 'new'
    }

    getPositionIndex() {
        if (this.isNew()) {
            return this.props.project.sortedPositions()?.length;
        }
        if(this.props.roleId) {
            return TB.findIndex(this.props.project.sortedPositions(), ['id', parseInt(this.props.roleId)]);
        }

        if (TB.isNil(this.constructor.PositionIndex)) return false;

        return this.constructor.PositionIndex
    }

    /**
     * The index of the position at project.positions
     */
    static PositionIndex = null;

    /**
     * The section shown on the progress wizard
     */
    static get StepSection(){
        return Project.ProjectSections.SectionPositions;
    }

    getStepName() {
        return false
    }

    /**
     * The subtitle shown on the form
     */
    getStepSubtitle() {

        let positionName = '#' + (this.getPositionIndex() + 1);

        // let position = this.currentPosition();
        // if (position.title) {
        //     positionName = position.title;
        // }

        if (this.positionFormRef?.current && this.positionFormRef?.current.editingSubStep) {
            return this.positionFormRef?.current.editingSubStep;
        }

        // return `Project Role: ${positionName}`;
        return `Open Position ${positionName}`;
    }

    static hasCompleted(project)
    {
        return project.validatePosition(this.PositionIndex);
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(project) {

        if (!project.validatePosition(this.PositionIndex)) {
            return this;
        }

        return false
    };

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;


        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {
            projectId
        })
    }

    /**
     * The first invalid field
     */
    invalidFields() {
        if (!this.positionFormRef.current || !this.positionFormRef.current.formRef?.current) {
            return false
        }
        let invalid = this.positionFormRef.current.formRef?.current?.forceValidate();

        if(invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return invalid;
    }

    positionAtIndex(index)
    {
        if (this.isNew()) return this.props.project.newPosition();

        let position = this.props.project.sortedPositions()[index];

        if (!position) {
            return;
        }

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position});
        }

        return position;
    }

    currentPosition()
    {
        let position
        if (this.isNew()) position = this.props.project.newPosition()
        if (TB.isDefined(this.props.roleId) && this.getPositionIndex() > -1) {
            position = TB.find(this.props.project.sortedPositions(), ['id', parseInt(this.props.roleId)])
        }else {
            let positionIndex = this.getPositionIndex();
            position = this.props.project.positions[positionIndex];
        }

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position})
        }

        return position
    }

    copyPreviousPosition() {
        if (this.isNew() && !this.props.project.sortedPositions(true).length) {
            return false;
        }else if(!this.getPositionIndex() || !this.positionAtIndex(this.getPositionIndex() - 1)) {
            return false
        }

        return this.syncPositionWithPrevious.bind(this)
    }

    async syncPositionWithPrevious() {
        let previousPosition = this.isNew() ? TB.last(this.props.project.sortedPositions(true)) : this.positionAtIndex(
            this.getPositionIndex() - 1
        );

        let {
            skills,
            disciplines,
            templates,
            // template_name,
            industries,
            description,
            max_rate,
            target_rate,
            target_rate_is_visible,
            wants_intermediate_experience,
            wants_senior_experience,
            wants_junior_experience
        } = {...previousPosition};

        await this.updatePosition({
            skills,
            disciplines,
            // template_id,
            templates,
            industries,
            description,
            max_rate,
            target_rate,
            target_rate_is_visible,
            wants_intermediate_experience,
            wants_senior_experience,
            wants_junior_experience
        });
        await this.props.onSubmit(this.props.project)
        // if(!this.props.params?.new) await this.savePosition();
        // else this.promisedState({editingPositionInfo: false})
    }

    async updatePosition(props)
    {
        // console.log('PositionStep @ updatePosition -> props', props);
        // console.log('PositionStep @ updatePosition -> currentPosition()', {...this.currentPosition()});
        this.props.toggleDisabled(this.currentPosition().needsSetup())

        let project = this.updateModelProp(
            'positions',
            this.getPositionIndex(),
            ProjectPosition.make({...this.currentPosition(), ...props})
        );
        if (this.props.isDisabled) return;

        project.positions_count = this.props.project.positions.length;

        if (this.props.project?.isNew?.() && !this.props.shouldBeRedirected?.() && this.props.project.canAddPositions()) {
            project.positions_count = project.positions_count + 1;
        }

        console.log('updatePosition', project)
        await this.onChange(project);

        return project;
        // this.props.toggleDisabled(this.currentPosition().needsSetup())
    }

    renderFormFooter()
    {
        let position = this.currentPosition();
        let positionIndex = this.getPositionIndex() + 1;

        return (
               <PositionWizardLayout
                   key={this.props.roleId}
                   roleId={this.props.roleId}
                   positionIndex={positionIndex}
                   isDisabled={this.props.isDisabled}
                   goBack={this.props.goBack}
                   copyPreviousPosition={this.copyPreviousPosition()}
                   onFinish={this.props.goToNextStep}/>
        )
    }
}